import type { ReactNode } from "react";

export enum BlockingModalType {
  loading = "loading",
  confirm = "confirm",
}

export interface BlockingModalOptions {
  title: string;
  content: ReactNode;
}

export type BlockingModalState = {
  visible: boolean;
  type: BlockingModalType;
  handleCancel?: () => void;
  options: BlockingModalOptions;
};
